import React from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import AlertMessage from '../../components/AlertMessage'
import FormInputField from '../../components/FormInputField'
import PageLoader from '../../components/PageLoader'
import integrationsActions from '../../integrations/actions'

class GitlabIntegrationCreationModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      gitlabPrivateToken: '',
      gitlabUrl: 'https://gitlab.com'
    }
  }

  componentDidUpdate(prevProps) {
    const { activationStatus: prevActivationStatus } = prevProps
    const { activationStatus, onClose } = this.props

    if (prevActivationStatus === 'activating' && activationStatus === 'succeeded') {
      onClose()
    }
  }

  handleSubmit(event) {
    const { dispatch } = this.props
    const { gitlabPrivateToken, gitlabUrl } = this.state

    event.preventDefault()

    if (gitlabPrivateToken === '') {
      this.privateTokenField.showAsInvalid()
    } else if (gitlabUrl === '') {
      this.urlField.showAsInvalid()
    } else {
      dispatch(integrationsActions.activate(
        'gitlab',
        gitlabPrivateToken,
        gitlabUrl
      ))
    }
  }

  setGitlabPrivateToken(gitlabPrivateToken) {
    this.setState({
      gitlabPrivateToken
    })
  }

  setGitlabUrl(gitlabUrl) {
    this.setState({
      gitlabUrl
    })
  }

  render() {
    const {
      activationError,
      activationStatus,
      isOpen,
      onClose,
      t
    } = this.props

    const { gitlabPrivateToken, gitlabUrl } = this.state

    return (
      <Modal isOpen={isOpen} toggle={() => onClose()}>
        <Form>
          <ModalHeader toggle={() => onClose()}>
            {t('GitlabIntegrationCreationModal.title')}
          </ModalHeader>
          <ModalBody>
            <FormInputField
              inputId="gitlab-url"
              inputName="gitlab_url"
              inputType="text"
              labelText={t('Integrations.fields.url')}
              onChange={({ target: { value } }) => this.setGitlabUrl(value)}
              ref={(component) => { this.urlField = component }}
              value={gitlabUrl}
            />

            <FormInputField
              inputId="gitlab-private-token"
              inputName="gitlab_private_token"
              inputType="text"
              labelText={t('Integrations.fields.privateToken')}
              onChange={({ target: { value } }) => this.setGitlabPrivateToken(value)}
              ref={(component) => { this.privateTokenField = component }}
              value={gitlabPrivateToken}
            />

            {(activationStatus === 'activating') && (
              <PageLoader message={t('GitlabIntegrationCreationModal.activating')} />
            )}

            {activationStatus === 'failed' && (
              <AlertMessage>
                {typeof activationError === 'string'
                  ? activationError
                  : t('errors.somethingWentWrong', { ns: 'commons' })}
              </AlertMessage>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => onClose()}>
              {t('buttons.cancel', { ns: 'commons' })}
            </Button>
            <Button
              color="primary"
              onClick={(event) => this.handleSubmit(event)}
              type="submit"
            >
              {t('Integrations.buttons.activate')}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    )
  }
}

GitlabIntegrationCreationModal.propTypes = {
  activationError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  activationStatus: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

GitlabIntegrationCreationModal.defaultProps = {
  activationError: null,
  activationStatus: 'idle'
}

const mapStateToProps = ({
  integrations: {
    activationError,
    activationStatus
  }
}) => ({
  activationError,
  activationStatus
})

export default withTranslation(['SettingsPage', 'commons'])(
  connect(mapStateToProps)(GitlabIntegrationCreationModal)
)
